import { render, staticRenderFns } from "./InovativeIdea.vue?vue&type=template&id=862b396c&"
import script from "./InovativeIdea.vue?vue&type=script&lang=js&"
export * from "./InovativeIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports